const features = {
  sleep: { kicker:'REST, SEEN DIFFERENTLY', title:'A clearer view of your nights.', description:'Explore your sleep patterns over time and build a more mindful evening routine, one night at a time.', screen:window.AH_ASSETS["app-sleep.webp"], screenAlt:'Actual Anywhere Healing app Sleep screen showing a sleep summary and stages', caption:'Sleep detail · captured app screen', linkLabel:'Open the Sleep screen at full size' },
  stress: { kicker:'A MOMENT TO CHECK IN', title:'Find room in the busy.', description:'Follow stress patterns in your daily view, then choose a calming routine when you want a mindful pause.', screen:window.AH_ASSETS["app-wellness.webp"], screenAlt:'Anywhere Healing app screen showing wellness session choices including Calm and Relax', caption:'Wellness choices · captured app screen', linkLabel:'Open the wellness sessions screen at full size' },
  insights: { kicker:'MAKE SENSE OF THE SIGNALS', title:'Patterns become perspective.', description:'Explore sleep trends and session observations in the app. The preview values are illustrative examples of how a personal view can look.', screen:window.AH_ASSETS["experience-insights-example.png"], screenAlt:'Illustrative sleep insights preview with sample values', caption:'Sleep insights · illustrative example', linkLabel:'Open the illustrative sleep insights preview at full size' },
  sessions: { kicker:'YOUR TIME, YOUR RITUAL', title:'Pause with purpose.', description:'Choose a guided frequency-based wellness session in the app, then make a little time to relax and reconnect with your routine.', screen:window.AH_ASSETS["app-session.webp"], screenAlt:'Actual Anywhere Healing app Deep Sleep session in progress screen', caption:'Session in progress · captured app screen', linkLabel:'Open the active session screen at full size' }
};

const tabs = Array.from(document.querySelectorAll('[role="tab"]'));
const insightsSlides = [
  {screen:window.AH_ASSETS["experience-insights-example.png"], alt:'Illustrative sleep insights preview with sample values', caption:'Sleep insights · illustrative example', label:'Open the illustrative sleep insights preview at full size'},
  {screen:window.AH_ASSETS["experience-session-observation-example.png"], alt:'Illustrative session observation preview with sample values', caption:'Session observation · illustrative example', label:'Open the illustrative session observation preview at full size'}
];
const visual = document.getElementById('explorer-visual');
const controls = document.getElementById('screen-controls');
const dots = Array.from(controls.querySelectorAll('.screen-dot'));
const screen = document.getElementById('app-screen');
const preview = document.getElementById('app-preview');
const link = document.getElementById('app-screen-link');
const fullLink = document.getElementById('screen-full-link');
const caption = document.getElementById('screen-caption');
let activeFeature = 'sleep';
let activeSlide = 0;
let slideTimer;

function showInsightsSlide(index, announce = false) {
  activeSlide = index;
  const slide = insightsSlides[index];
  preview.src = slide.screen;
  preview.alt = window.AH_T(slide.alt);
  link.href = fullLink.href = slide.screen;
  link.setAttribute('aria-label', window.AH_T(slide.label));
  caption.textContent = window.AH_T(slide.caption);
  dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
  document.getElementById('slide-status').textContent = announce ? `${index + 1} ${window.AH_T("of")} ${insightsSlides.length}: ${window.AH_T(slide.caption)}` : '';
}

function startInsightsRotation() {
  clearInterval(slideTimer);
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  slideTimer = setInterval(() => {
    if (activeFeature !== 'insights' || document.hidden || visual.matches(':hover') || visual.contains(document.activeElement)) return;
    showInsightsSlide((activeSlide + 1) % insightsSlides.length);
  }, 5000);
}

function selectFeature(key, focus = false) {
  const item = features[key];
  if (!item) return;
  activeFeature = key;
  clearInterval(slideTimer);
  for (const tab of tabs) {
    const active = tab.dataset.feature === key;
    tab.setAttribute('aria-selected', String(active));
    tab.tabIndex = active ? 0 : -1;
    if (active && focus) tab.focus();
  }
  document.getElementById('feature-panel').setAttribute('aria-labelledby', `tab-${key}`);
  document.getElementById('feature-kicker').textContent = window.AH_T(item.kicker);
  document.getElementById('feature-title').textContent = window.AH_T(item.title);
  document.getElementById('feature-description').textContent = window.AH_T(item.description);
  const isInsights = key === 'insights';
  visual.classList.toggle('has-carousel', isInsights);
  controls.hidden = !isInsights;
  screen.hidden = isInsights;
  preview.hidden = !isInsights;
  if (isInsights) {
    showInsightsSlide(0);
    startInsightsRotation();
  } else {
    preview.removeAttribute('src');
    screen.src = item.screen;
    screen.alt = window.AH_T(item.screenAlt);
    screen.classList.toggle('crop-notification', key === 'stress');
    link.href = fullLink.href = item.fullScreen || item.screen;
    link.setAttribute('aria-label', window.AH_T(item.linkLabel));
    caption.textContent = window.AH_T(item.caption);
  }
}
dots.forEach((dot, index) => dot.addEventListener('click', () => { showInsightsSlide(index, true); startInsightsRotation(); }));
tabs.forEach((tab, index) => {
  tab.addEventListener('click', () => selectFeature(tab.dataset.feature));
  tab.addEventListener('keydown', (event) => {
    const direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 0;
    if (direction) {event.preventDefault(); selectFeature(tabs[(index + direction + tabs.length) % tabs.length].dataset.feature, true);}
    if (event.key === 'Home' || event.key === 'End') {event.preventDefault(); selectFeature(tabs[event.key === 'Home' ? 0 : tabs.length - 1].dataset.feature, true);}
  });
});
selectFeature('sleep');
document.querySelectorAll('.story-poster, .film-poster').forEach((button) => {
  button.addEventListener('click', async () => {
    const video = button.nextElementSibling;
    document.querySelectorAll('.story-video-stage video, .film-video-shell video').forEach((other) => {
      if (other !== video) other.pause();
    });
    button.hidden = true;
    video.hidden = false;
    try { await video.play(); } catch { video.focus(); }
  });
});
document.getElementById('year').textContent = new Date().getFullYear();

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const ringLayer = document.getElementById('journey-ring');
const heroArt = document.querySelector('.hero-art');
const purchaseArt = document.querySelector('.purchase-art');
const journeyBeats = Array.from(document.querySelectorAll('.journey-beat'));
let ringOrigin = null;
let ringBase = 1;
let ringKnots = [];
let ringFrame = 0;
let purchaseKnot = null;

if ('IntersectionObserver' in window && !prefersReducedMotion.matches) {
  const targets = document.querySelectorAll('.science-copy, .science-art, .journey-copy, .journey-visual, .section-heading, .explorer, .day-card, .checkout-feature, .product-film-copy, .product-film-frame, .stories-heading, .video-card, .difference-intro, .comparison-explainer, .product-details, .purchase-copy, .purchase-art, .about-emblem, .about-copy');
  targets.forEach(target => target.classList.add('scroll-reveal'));
  document.documentElement.classList.add('has-motion');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, {threshold:.06, rootMargin:'0px 0px -3% 0px'});
  targets.forEach(target => observer.observe(target));
}

function ringKnot(scroll, x, y, size, turn = 0, opacity = 1) {
  return {scroll, x, y, size, turn, opacity};
}

function addTransitionBridge(previous, next) {
  if (next.scroll - previous.scroll < 180) return;
  const mobile = window.innerWidth <= 700;
  const size = mobile ? 70 : 150;
  ringKnots.push(ringKnot(
    previous.scroll + (next.scroll - previous.scroll) * .52,
    window.innerWidth - size - (mobile ? 10 : 18),
    mobile ? 8 : 102,
    size,
    (previous.turn + next.turn) / 2
  ));
}

function buildRingPath() {
  if (!ringOrigin) return;
  const viewportHeight = window.innerHeight;
  const mobile = window.innerWidth <= 700;
  const originRect = ringOrigin.getBoundingClientRect();
  ringBase = originRect.width;
  ringLayer.style.setProperty('--ring-base-width', `${ringBase}px`);
  ringKnots = [ringKnot(0, originRect.left, originRect.top + window.scrollY, ringBase)];

  const science = document.getElementById('science');
  const scienceMarker = document.getElementById('anchor-science');
  const scienceRect = scienceMarker.getBoundingClientRect();
  const scienceDocumentCenter = scienceRect.top + window.scrollY + scienceRect.height / 2;
  const centerSize = Math.min(ringBase * (mobile ? .58 : .73), mobile ? 220 : 395);
  const centerScroll = Math.max(100, science.offsetTop - viewportHeight * .78);
  ringKnots.push(ringKnot(centerScroll, (window.innerWidth - centerSize) / 2, (viewportHeight - centerSize) / 2, centerSize, -5));

  if (mobile) {
    const edgeSize = 90;
    const edge = ringKnot(science.offsetTop - viewportHeight * .18, window.innerWidth - edgeSize - 12, 80, edgeSize, 3);
    ringKnots.push(edge);
  }
  const scienceScroll = scienceDocumentCenter - viewportHeight * .5;
  const scienceSize = scienceRect.width;
  const scienceStop = ringKnot(scienceScroll, scienceRect.left, (viewportHeight - scienceSize) / 2, scienceSize, 8);
  const scienceLeave = scienceScroll + (mobile ? 90 : 135);
  ringKnots.push(scienceStop, {...scienceStop, scroll:scienceLeave});
  const exitSize = mobile ? 70 : 124;
  ringKnots.push(ringKnot(scienceLeave + 110, window.innerWidth - exitSize - 15, mobile ? 10 : 28, exitSize, 5));

  journeyBeats.forEach((beat, index) => {
    const marker = beat.querySelector('.journey-anchor');
    const markerRect = marker.getBoundingClientRect();
    const innerRect = beat.querySelector('.journey-beat-inner').getBoundingClientRect();
    const dwell = Math.max(0, beat.offsetHeight - viewportHeight);
    const enter = ringKnot(beat.offsetTop + dwell * .13, markerRect.left, markerRect.top - innerRect.top, markerRect.width, [-5,6,-4,5][index]);
    const leave = {...enter, scroll:beat.offsetTop + dwell * .88};
    addTransitionBridge(ringKnots[ringKnots.length - 1], enter);
    ringKnots.push(enter, leave);
  });

  if (mobile) {
    const experienceStart = document.getElementById('experience').offsetTop;
    ringKnots.push(ringKnot(experienceStart - viewportHeight * .08, window.innerWidth - 66, 12, 54, 2));
  }

  const explorerMarker = document.getElementById('anchor-explorer');
  const explorerRect = explorerMarker.getBoundingClientRect();
  const explorerScroll = explorerRect.top + window.scrollY + explorerRect.height / 2 - viewportHeight * .5;
  const explorer = ringKnot(explorerScroll, explorerRect.left, (viewportHeight - explorerRect.width) / 2, explorerRect.width, 3);
  addTransitionBridge(ringKnots[ringKnots.length - 1], explorer);
  ringKnots.push(explorer, {...explorer, scroll:explorerScroll + (mobile ? 110 : 190)});

  const edgeSize = mobile ? 64 : 98;
  const edgeX = window.innerWidth - edgeSize - (mobile ? 10 : 15);
  const edgeY = mobile ? 8 : 125;
  const cardScroll = document.querySelector('.lifestyle-row').getBoundingClientRect().top + window.scrollY + 90;
  const cardKnot = ringKnot(cardScroll, edgeX, edgeY, edgeSize, -5, .87);
  ringKnots.push(cardKnot);
  const stories = document.getElementById('stories');
  ringKnots.push({...cardKnot, scroll:stories.offsetTop + 140, turn:6, opacity:.72});
  const difference = document.getElementById('difference');

  const comparisonMarker = document.getElementById('anchor-comparison');
  const comparisonRect = comparisonMarker.getBoundingClientRect();
  const comparisonStageRect = comparisonMarker.parentElement.getBoundingClientRect();
  const comparisonCenter = comparisonRect.top + window.scrollY + comparisonRect.height / 2;
  const comparisonScroll = comparisonCenter - viewportHeight * .5;
  const comparisonStop = ringKnot(comparisonScroll, comparisonRect.left, (viewportHeight - comparisonRect.width) / 2, comparisonRect.width, -2);
  ringKnots.push(mobile
    ? ringKnot(Math.min(difference.offsetTop - 50, comparisonScroll - 260), window.innerWidth - 36, 10, 40, -4, .8)
    : {...cardKnot, scroll:Math.min(difference.offsetTop + 90, comparisonScroll - 260), turn:-4, opacity:.8});
  ringKnots.push(mobile
    ? ringKnot(comparisonScroll - 190, window.innerWidth - 36, 10, 40, -4, .8)
    : {...cardKnot, scroll:comparisonScroll - 190, turn:-4, opacity:.8});
  const preArrivalScroll = comparisonScroll - 35;
  ringKnots.push(mobile
    ? ringKnot(preArrivalScroll, window.innerWidth - 34, comparisonStageRect.top + window.scrollY - preArrivalScroll + comparisonStageRect.height * .48 - 27, 54, -3)
    : ringKnot(preArrivalScroll, comparisonStageRect.right - 95, comparisonStageRect.top + window.scrollY - preArrivalScroll + 28, 90, -3));
  ringKnots.push(comparisonStop, {...comparisonStop, scroll:comparisonScroll + (mobile ? 95 : 50)});
  const dock = mobile
    ? ringKnot(comparisonScroll + 245, window.innerWidth - 36, 10, 40, 3, .8)
    : ringKnot(comparisonScroll + 195, window.innerWidth - 112, 105, 90, 3, .8);
  ringKnots.push(dock);

  const artRect = purchaseArt.getBoundingClientRect();
  const artSize = mobile ? Math.min(340, artRect.width * .95) : Math.min(490, artRect.width * .95);
  const artCenterDocument = artRect.top + window.scrollY + artRect.height / 2;
  purchaseKnot = ringKnot(artCenterDocument - viewportHeight * .5, artRect.left + (artRect.width - artSize) / 2, (viewportHeight - artSize) / 2, artSize, 8);
  ringKnots.push({...dock, scroll:purchaseKnot.scroll - 215, turn:5}, ringKnot(purchaseKnot.scroll - 70, dock.x, Math.min(viewportHeight * .48, 345), dock.size, 5, .9));
  ringKnots.push(purchaseKnot);
  ringKnots.sort((a,b) => a.scroll - b.scroll);

  queueRing();
}

function interpolate(a,b,t) { return a + (b - a) * t; }
function updateRing() {
  ringFrame = 0;
  if (!ringOrigin || prefersReducedMotion.matches) return;
  const position = window.scrollY;
  let current = ringKnots[0];
  if (position >= purchaseKnot.scroll) {
    const art = purchaseArt.getBoundingClientRect();
    current = {...purchaseKnot, x:art.left + (art.width - purchaseKnot.size) / 2, y:art.top + (art.height - purchaseKnot.size) / 2, opacity:Math.max(0, Math.min(1, art.bottom / 160))};
  } else {
    for (let index=1; index<ringKnots.length; index++) {
      if (position > ringKnots[index].scroll) continue;
      const previous = ringKnots[index - 1];
      const next = ringKnots[index];
      const fraction = Math.max(0, Math.min(1, (position - previous.scroll) / Math.max(1, next.scroll - previous.scroll)));
      const eased = fraction * fraction * (3 - 2 * fraction);
      current = ringKnot(position,
        interpolate(previous.x, next.x, eased),
        interpolate(previous.y, next.y, eased),
        interpolate(previous.size, next.size, eased),
        interpolate(previous.turn, next.turn, eased),
        interpolate(previous.opacity, next.opacity, eased));
      break;
    }
  }
  const videoIsPlaying = Array.from(document.querySelectorAll('.story-video-stage video')).some(video => !video.paused);
  ringLayer.style.setProperty('--ring-x', `${current.x.toFixed(2)}px`);
  ringLayer.style.setProperty('--ring-y', `${current.y.toFixed(2)}px`);
  ringLayer.style.setProperty('--ring-scale', (current.size / ringBase).toFixed(4));
  ringLayer.style.setProperty('--ring-turn', `${current.turn.toFixed(2)}deg`);
  ringLayer.style.setProperty('--ring-opacity', videoIsPlaying ? '0' : current.opacity.toFixed(3));
}
function queueRing() {
  if (!ringFrame) ringFrame = requestAnimationFrame(updateRing);
}
function enableRingJourney() {
  if (ringOrigin || prefersReducedMotion.matches) return;
  ringOrigin = document.createElement('div');
  ringOrigin.className = 'ring-origin';
  ringLayer.before(ringOrigin);
  document.body.appendChild(ringLayer);
  ringLayer.setAttribute('aria-hidden', 'true');
  ringLayer.classList.add('ring-moving');
  document.documentElement.classList.add('ring-journey-ready');
  buildRingPath();
}
function disableRingJourney() {
  if (!ringOrigin) return;
  ringOrigin.replaceWith(ringLayer);
  ringOrigin = null;
  ringLayer.classList.remove('ring-moving');
  ringLayer.removeAttribute('aria-hidden');
  ringLayer.removeAttribute('style');
  document.documentElement.classList.remove('ring-journey-ready');
  document.querySelectorAll('.scroll-reveal').forEach(target => target.classList.add('is-revealed'));
}
window.addEventListener('scroll', queueRing, {passive:true});
window.addEventListener('resize', buildRingPath, {passive:true});
window.addEventListener('load', buildRingPath, {once:true});
document.querySelectorAll('.story-video-stage video').forEach(video => {
  ['play','pause','ended'].forEach(event => video.addEventListener(event, queueRing));
});
prefersReducedMotion.addEventListener('change', () => {
  document.documentElement.classList.toggle('has-motion', !prefersReducedMotion.matches);
  if (prefersReducedMotion.matches) disableRingJourney();
  else enableRingJourney();
});
enableRingJourney();

const mobileShop = document.getElementById('mobile-shop');
const purchaseSection = document.getElementById('purchase');
const checkoutAction = document.querySelector('.checkout-actions');
function updateMobileShop() {
  const checkoutActionRect = checkoutAction.getBoundingClientRect();
  const checkoutActionVisible = checkoutActionRect.top < window.innerHeight * .93 && checkoutActionRect.bottom > 0;
  const show = window.innerWidth <= 700 &&
    document.querySelector('.hero').getBoundingClientRect().bottom < 0 &&
    purchaseSection.getBoundingClientRect().top > window.innerHeight * .7 &&
    !checkoutActionVisible;
  mobileShop.classList.toggle('is-visible', show);
  mobileShop.setAttribute('aria-hidden', String(!show));
  mobileShop.tabIndex = show ? 0 : -1;
}
window.addEventListener('scroll', updateMobileShop, {passive:true});
window.addEventListener('resize', updateMobileShop, {passive:true});
window.addEventListener('load', updateMobileShop, {once:true});
updateMobileShop();
